module.exports = __webpack_public_path__ + "img/ams.8956c2ea.jpg";